/**
 * Parfüm-Test: client-side matching quiz. No backend calls — scores our own
 * products and the fragrances we plan to add next against the visitor's
 * answers. Result: "Bei uns zum Testen" (3 of ours, for women at most 2) and
 * "Bald bei uns" (the rest up to 6, with a "Will ich testen" vote + optional notify mail).
 * A fragrance for the other gender is never shown.
 */
(function () {
  'use strict';

  // Our real, sellable fragrances. `handle` must match the live product handle.
  // Image and "ab" price come live from the section (#FragranceQuizCatalog).
  // gender = product metafield custom.duft_gender (Herren / Damen / Unisex).
  var OWN_FRAGRANCES = [
    { handle: 'louis-vuitton-imagination-probe', name: 'Louis Vuitton Imagination', gender: 'herren', seasons: ['fruhling', 'sommer', 'ganzjahrig'], notes: ['frisch'], anlass: ['buro', 'klassiker'], intensity: 'moderat', owned: true, variants: { '1': 58897949163868, '5': 58897949262172 } },
    { handle: 'louis-vuitton-ombre-nomade-probe', name: 'Louis Vuitton Ombre Nomade', gender: 'unisex', seasons: ['herbst', 'winter'], notes: ['orientalisch', 'holzig'], anlass: ['date', 'klassiker'], intensity: 'intensiv', owned: true, variants: { '1': 58898129289564, '5': 58898129387868 } },
    { handle: 'chanel-bleu-de-chanel-probe', name: 'Chanel Bleu de Chanel', gender: 'herren', seasons: ['ganzjahrig'], notes: ['holzig', 'frisch'], anlass: ['buro', 'klassiker'], intensity: 'moderat', owned: true, variants: { '1': 58898281791836, '5': 58898244338012 } },
    { handle: 'parfums-de-marly-layton-probe', name: 'Parfums de Marly Layton', gender: 'herren', seasons: ['herbst', 'winter'], notes: ['gourmand', 'orientalisch'], anlass: ['date', 'klassiker'], intensity: 'intensiv', owned: true, variants: { '1': 58898281890140, '5': 58898244436316 } },
    { handle: 'xerjoff-1861-naxos-probe', name: 'Xerjoff 1861 Naxos', gender: 'unisex', seasons: ['herbst', 'winter'], notes: ['gourmand', 'orientalisch'], anlass: ['date', 'klassiker'], intensity: 'intensiv', owned: true, variants: { '1': 58898281988444, '5': 58898244567388 } },
    { handle: 'louis-vuitton-afternoon-swim-probe', name: 'Louis Vuitton Afternoon Swim', gender: 'unisex', seasons: ['fruhling', 'sommer'], notes: ['frisch'], anlass: ['buro'], intensity: 'dezent', owned: true, variants: { '1': 58898282086748, '5': 58898244665692 } },
    { handle: 'tom-ford-lost-cherry-probe', name: 'Tom Ford Lost Cherry', gender: 'unisex', seasons: ['herbst', 'winter'], notes: ['gourmand', 'orientalisch'], anlass: ['date'], intensity: 'intensiv', owned: true, variants: { '1': 58898282217820, '5': 58898244895068 } },
    { handle: 'parfums-de-marly-delina-probe', name: 'Parfums de Marly Delina', gender: 'damen', seasons: ['fruhling', 'sommer'], notes: ['blumig', 'gourmand'], anlass: ['date', 'klassiker', 'buro'], intensity: 'moderat', owned: true, variants: { '1': 58898282414428, '5': 58898244993372 } },
    { handle: 'louis-vuitton-pacific-chill-probe', name: 'Louis Vuitton Pacific Chill', gender: 'unisex', seasons: ['fruhling', 'sommer'], notes: ['frisch'], anlass: ['buro'], intensity: 'dezent', owned: true, variants: { '1': 58898282545500, '5': 58898245091676 } },
    { handle: 'dior-homme-intense-probe', name: 'Dior Homme Intense', gender: 'herren', seasons: ['herbst', 'winter'], notes: ['blumig', 'holzig'], anlass: ['buro', 'date', 'klassiker'], intensity: 'intensiv', owned: true, variants: { '1': 58898282676572, '5': 58898245189980 } },
    { handle: 'dior-sauvage-probe', name: 'Dior Sauvage', gender: 'herren', seasons: ['ganzjahrig'], notes: ['frisch', 'holzig'], anlass: ['buro', 'date'], intensity: 'intensiv', owned: true, variants: { '1': 59074702606684, '5': 59074702704988 } },
  ];

  // Düfte, die wir als Nächstes aufnehmen wollen (Stand 05.10.2026):
  // Bestseller bei deutschen Probenshops + Louis Vuitton (ohne Les Extraits und
  // die Pur-Linie). Sie erscheinen im Ergebnis unter "Bald bei uns" mit einem
  // "Will ich testen"-Button (WhatsApp). Wird einer davon ins Sortiment
  // aufgenommen: hier löschen und oben in OWN_FRAGRANCES eintragen.
  var PLANNED_FRAGRANCES = [
    { name: 'Dior Sauvage Elixir', gender: 'herren', seasons: ['herbst', 'winter'], notes: ['orientalisch', 'holzig'], anlass: ['date', 'klassiker'], intensity: 'intensiv' },
    { name: 'Dior Fahrenheit', gender: 'herren', seasons: ['herbst', 'winter'], notes: ['holzig'], anlass: ['klassiker'], intensity: 'intensiv' },
    { name: 'Prada L’Homme', gender: 'herren', seasons: ['ganzjahrig'], notes: ['blumig', 'holzig'], anlass: ['buro', 'klassiker'], intensity: 'moderat' },
    { name: 'Prada Luna Rossa Ocean', gender: 'herren', seasons: ['fruhling', 'sommer'], notes: ['frisch'], anlass: ['buro'], intensity: 'moderat' },
    { name: 'Giorgio Armani Stronger With You Intensely', gender: 'herren', seasons: ['herbst', 'winter'], notes: ['gourmand', 'orientalisch'], anlass: ['date'], intensity: 'intensiv' },
    { name: 'Jean Paul Gaultier Le Male', gender: 'herren', seasons: ['herbst', 'winter'], notes: ['gourmand'], anlass: ['date'], intensity: 'intensiv' },
    { name: 'Jean Paul Gaultier Le Male Le Parfum', gender: 'herren', seasons: ['herbst', 'winter'], notes: ['orientalisch', 'gourmand'], anlass: ['date', 'klassiker'], intensity: 'intensiv' },
    { name: 'Jean Paul Gaultier Le Male Elixir', gender: 'herren', seasons: ['winter'], notes: ['gourmand', 'orientalisch'], anlass: ['date'], intensity: 'intensiv' },
    { name: 'Jean Paul Gaultier Le Beau Le Parfum', gender: 'herren', seasons: ['fruhling', 'sommer'], notes: ['gourmand', 'frisch'], anlass: ['date'], intensity: 'intensiv' },
    { name: 'Paco Rabanne 1 Million', gender: 'herren', seasons: ['herbst', 'winter'], notes: ['gourmand', 'orientalisch'], anlass: ['date'], intensity: 'intensiv' },
    { name: 'Paco Rabanne Invictus', gender: 'herren', seasons: ['fruhling', 'sommer'], notes: ['frisch'], anlass: ['date', 'buro'], intensity: 'intensiv' },
    { name: 'Yves Saint Laurent La Nuit de L’Homme', gender: 'herren', seasons: ['herbst', 'winter'], notes: ['orientalisch', 'holzig'], anlass: ['date'], intensity: 'moderat' },
    { name: 'Dolce & Gabbana The One for Men', gender: 'herren', seasons: ['herbst', 'winter'], notes: ['orientalisch'], anlass: ['date', 'klassiker'], intensity: 'moderat' },
    { name: 'Dolce & Gabbana Light Blue Eau Intense Pour Homme', gender: 'herren', seasons: ['sommer'], notes: ['frisch'], anlass: ['buro'], intensity: 'moderat' },
    { name: 'Hugo Boss Bottled', gender: 'herren', seasons: ['ganzjahrig'], notes: ['holzig'], anlass: ['buro'], intensity: 'moderat' },
    { name: 'Givenchy Gentleman Eau de Parfum', gender: 'herren', seasons: ['herbst', 'winter'], notes: ['blumig', 'holzig'], anlass: ['klassiker', 'date'], intensity: 'moderat' },
    { name: 'Valentino Uomo Born In Roma', gender: 'herren', seasons: ['ganzjahrig'], notes: ['holzig', 'frisch'], anlass: ['buro', 'date'], intensity: 'moderat' },
    { name: 'Viktor & Rolf Spicebomb Extreme', gender: 'herren', seasons: ['winter'], notes: ['orientalisch', 'gourmand'], anlass: ['date'], intensity: 'intensiv' },
    { name: 'Tom Ford Noir Extreme', gender: 'herren', seasons: ['herbst', 'winter'], notes: ['orientalisch', 'gourmand'], anlass: ['date'], intensity: 'intensiv' },
    { name: 'Parfums de Marly Althaïr', gender: 'herren', seasons: ['herbst', 'winter'], notes: ['gourmand', 'orientalisch'], anlass: ['date'], intensity: 'intensiv' },
    { name: 'Parfums de Marly Herod', gender: 'herren', seasons: ['winter'], notes: ['orientalisch', 'gourmand'], anlass: ['klassiker', 'date'], intensity: 'intensiv' },
    { name: 'Parfums de Marly Percival', gender: 'herren', seasons: ['fruhling', 'ganzjahrig'], notes: ['frisch', 'holzig'], anlass: ['buro'], intensity: 'moderat' },
    { name: 'Parfums de Marly Layton Exclusif', gender: 'herren', seasons: ['winter'], notes: ['orientalisch', 'holzig'], anlass: ['date', 'klassiker'], intensity: 'intensiv' },
    { name: 'Armaf Club de Nuit Intense Man', gender: 'herren', seasons: ['ganzjahrig'], notes: ['frisch', 'holzig'], anlass: ['date'], intensity: 'intensiv' },
    { name: 'Louis Vuitton Nouveau Monde', gender: 'herren', seasons: ['herbst', 'winter'], notes: ['orientalisch'], anlass: ['date', 'klassiker'], intensity: 'intensiv' },
    { name: 'Louis Vuitton Sur la Route', gender: 'herren', seasons: ['fruhling', 'sommer'], notes: ['frisch'], anlass: ['buro'], intensity: 'dezent' },
    { name: 'Louis Vuitton Orage', gender: 'herren', seasons: ['ganzjahrig'], notes: ['holzig'], anlass: ['buro', 'klassiker'], intensity: 'moderat' },
    { name: 'Louis Vuitton Au Hasard', gender: 'herren', seasons: ['herbst', 'winter'], notes: ['holzig'], anlass: ['klassiker'], intensity: 'moderat' },
    { name: 'Louis Vuitton Météore', gender: 'herren', seasons: ['fruhling', 'sommer'], notes: ['frisch'], anlass: ['buro'], intensity: 'dezent' },
    { name: 'Louis Vuitton L’Immensité', gender: 'herren', seasons: ['fruhling', 'sommer'], notes: ['frisch'], anlass: ['buro'], intensity: 'moderat' },
    { name: 'Prada Paradoxe', gender: 'damen', seasons: ['fruhling', 'ganzjahrig'], notes: ['blumig', 'gourmand'], anlass: ['buro', 'date'], intensity: 'moderat' },
    { name: 'Yves Saint Laurent Libre', gender: 'damen', seasons: ['ganzjahrig'], notes: ['blumig'], anlass: ['klassiker', 'date'], intensity: 'intensiv' },
    { name: 'Dior Miss Dior', gender: 'damen', seasons: ['fruhling'], notes: ['blumig'], anlass: ['date', 'klassiker'], intensity: 'moderat' },
    { name: 'Dior J’adore', gender: 'damen', seasons: ['fruhling', 'sommer'], notes: ['blumig'], anlass: ['buro', 'klassiker'], intensity: 'moderat' },
    { name: 'Dior Hypnotic Poison', gender: 'damen', seasons: ['herbst', 'winter'], notes: ['gourmand', 'orientalisch'], anlass: ['date'], intensity: 'intensiv' },
    { name: 'Narciso Rodriguez For Her', gender: 'damen', seasons: ['ganzjahrig'], notes: ['blumig'], anlass: ['klassiker', 'date'], intensity: 'moderat' },
    { name: 'Narciso Rodriguez For Her Pure Musc', gender: 'damen', seasons: ['ganzjahrig'], notes: ['blumig'], anlass: ['buro'], intensity: 'moderat' },
    { name: 'Narciso Rodriguez Narciso Poudrée', gender: 'damen', seasons: ['ganzjahrig'], notes: ['blumig'], anlass: ['buro', 'klassiker'], intensity: 'moderat' },
    { name: 'Gucci Flora Gorgeous Gardenia', gender: 'damen', seasons: ['fruhling', 'sommer'], notes: ['blumig', 'gourmand'], anlass: ['buro', 'date'], intensity: 'moderat' },
    { name: 'Gucci Flora Gorgeous Orchid', gender: 'damen', seasons: ['fruhling'], notes: ['blumig', 'gourmand'], anlass: ['date'], intensity: 'moderat' },
    { name: 'Guerlain Mon Guerlain', gender: 'damen', seasons: ['herbst', 'ganzjahrig'], notes: ['gourmand', 'blumig'], anlass: ['buro', 'date'], intensity: 'moderat' },
    { name: 'Kayali Vanilla 28', gender: 'damen', seasons: ['herbst', 'winter'], notes: ['gourmand'], anlass: ['date'], intensity: 'intensiv' },
    { name: 'Carolina Herrera Good Girl', gender: 'damen', seasons: ['herbst', 'winter'], notes: ['gourmand', 'blumig'], anlass: ['date'], intensity: 'intensiv' },
    { name: 'Burberry Goddess', gender: 'damen', seasons: ['herbst', 'winter'], notes: ['gourmand'], anlass: ['date'], intensity: 'intensiv' },
    { name: 'Kilian Love, Don’t Be Shy', gender: 'damen', seasons: ['herbst', 'winter'], notes: ['gourmand'], anlass: ['date'], intensity: 'intensiv' },
    { name: 'Parfums de Marly Valaya', gender: 'damen', seasons: ['fruhling', 'ganzjahrig'], notes: ['blumig'], anlass: ['buro'], intensity: 'dezent' },
    { name: 'Jean Paul Gaultier Divine', gender: 'damen', seasons: ['fruhling', 'sommer'], notes: ['blumig', 'frisch'], anlass: ['date'], intensity: 'moderat' },
    { name: 'Zadig & Voltaire This Is Her!', gender: 'damen', seasons: ['herbst', 'winter'], notes: ['gourmand'], anlass: ['date'], intensity: 'moderat' },
    { name: 'Dolce & Gabbana Devotion', gender: 'damen', seasons: ['herbst', 'winter'], notes: ['gourmand'], anlass: ['date'], intensity: 'moderat' },
    { name: 'Louis Vuitton Attrape-Rêves', gender: 'damen', seasons: ['herbst', 'winter'], notes: ['gourmand', 'blumig'], anlass: ['date'], intensity: 'moderat' },
    { name: 'Louis Vuitton Spell on You', gender: 'damen', seasons: ['fruhling'], notes: ['blumig'], anlass: ['date'], intensity: 'moderat' },
    { name: 'Louis Vuitton Rose des Vents', gender: 'damen', seasons: ['fruhling', 'sommer'], notes: ['blumig'], anlass: ['buro'], intensity: 'dezent' },
    { name: 'Louis Vuitton Le Jour se Lève', gender: 'damen', seasons: ['fruhling', 'sommer'], notes: ['frisch', 'blumig'], anlass: ['buro'], intensity: 'dezent' },
    { name: 'Louis Vuitton Cœur Battant', gender: 'damen', seasons: ['fruhling'], notes: ['blumig'], anlass: ['date'], intensity: 'moderat' },
    { name: 'Louis Vuitton Contre Moi', gender: 'damen', seasons: ['herbst', 'winter'], notes: ['gourmand'], anlass: ['date'], intensity: 'moderat' },
    { name: 'Louis Vuitton Apogée', gender: 'damen', seasons: ['fruhling'], notes: ['blumig'], anlass: ['buro'], intensity: 'dezent' },
    { name: 'Louis Vuitton Heures d’Absence', gender: 'damen', seasons: ['fruhling'], notes: ['blumig'], anlass: ['klassiker'], intensity: 'moderat' },
    { name: 'Louis Vuitton Mille Feux', gender: 'damen', seasons: ['herbst', 'winter'], notes: ['orientalisch', 'gourmand'], anlass: ['date'], intensity: 'intensiv' },
    { name: 'Louis Vuitton Matière Noire', gender: 'damen', seasons: ['herbst', 'winter'], notes: ['orientalisch'], anlass: ['klassiker'], intensity: 'intensiv' },
    { name: 'Louis Vuitton Dans la Peau', gender: 'damen', seasons: ['herbst'], notes: ['holzig', 'blumig'], anlass: ['klassiker'], intensity: 'moderat' },
    { name: 'Louis Vuitton Turbulences', gender: 'damen', seasons: ['fruhling', 'sommer'], notes: ['blumig'], anlass: ['date'], intensity: 'intensiv' },
    { name: 'Tom Ford Oud Wood', gender: 'unisex', seasons: ['herbst', 'winter'], notes: ['holzig', 'orientalisch'], anlass: ['klassiker', 'date'], intensity: 'moderat' },
    { name: 'Tom Ford Tobacco Vanille', gender: 'unisex', seasons: ['herbst', 'winter'], notes: ['gourmand', 'orientalisch'], anlass: ['klassiker'], intensity: 'intensiv' },
    { name: 'Tom Ford Ombré Leather', gender: 'unisex', seasons: ['herbst', 'winter'], notes: ['holzig'], anlass: ['klassiker'], intensity: 'intensiv' },
    { name: 'Tom Ford Fucking Fabulous', gender: 'unisex', seasons: ['herbst', 'winter'], notes: ['gourmand', 'orientalisch'], anlass: ['date'], intensity: 'intensiv' },
    { name: 'Tom Ford Soleil Blanc', gender: 'unisex', seasons: ['sommer'], notes: ['blumig', 'gourmand'], anlass: ['date'], intensity: 'moderat' },
    { name: 'Tom Ford Neroli Portofino', gender: 'unisex', seasons: ['sommer'], notes: ['frisch'], anlass: ['buro'], intensity: 'dezent' },
    { name: 'Xerjoff Erba Pura', gender: 'unisex', seasons: ['ganzjahrig'], notes: ['gourmand', 'frisch'], anlass: ['date'], intensity: 'intensiv' },
    { name: 'Xerjoff Accento', gender: 'unisex', seasons: ['fruhling', 'sommer'], notes: ['blumig', 'gourmand'], anlass: ['date'], intensity: 'intensiv' },
    { name: 'Xerjoff Alexandria II', gender: 'unisex', seasons: ['herbst', 'winter'], notes: ['orientalisch', 'holzig'], anlass: ['klassiker'], intensity: 'intensiv' },
    { name: 'Xerjoff 40 Knots', gender: 'unisex', seasons: ['sommer'], notes: ['frisch'], anlass: ['buro'], intensity: 'moderat' },
    { name: 'Kilian Angels’ Share', gender: 'unisex', seasons: ['herbst', 'winter'], notes: ['gourmand'], anlass: ['date'], intensity: 'intensiv' },
    { name: 'Kilian Back to Black', gender: 'unisex', seasons: ['herbst', 'winter'], notes: ['gourmand', 'orientalisch'], anlass: ['date'], intensity: 'intensiv' },
    { name: 'Initio Side Effect', gender: 'unisex', seasons: ['winter'], notes: ['gourmand', 'orientalisch'], anlass: ['date'], intensity: 'intensiv' },
    { name: 'Initio Musk Therapy', gender: 'unisex', seasons: ['ganzjahrig'], notes: ['blumig'], anlass: ['buro'], intensity: 'dezent' },
    { name: 'Initio Oud for Greatness', gender: 'unisex', seasons: ['winter'], notes: ['orientalisch'], anlass: ['klassiker'], intensity: 'intensiv' },
    { name: 'Montale Arabians Tonka', gender: 'unisex', seasons: ['herbst', 'winter'], notes: ['orientalisch', 'gourmand'], anlass: ['date'], intensity: 'intensiv' },
    { name: 'Montale Intense Café', gender: 'unisex', seasons: ['herbst', 'winter'], notes: ['gourmand', 'blumig'], anlass: ['date'], intensity: 'intensiv' },
    { name: 'Montale Roses Musk', gender: 'unisex', seasons: ['fruhling'], notes: ['blumig'], anlass: ['buro', 'date'], intensity: 'moderat' },
    { name: 'Maison Margiela By the Fireplace', gender: 'unisex', seasons: ['winter'], notes: ['gourmand'], anlass: ['klassiker'], intensity: 'moderat' },
    { name: 'Maison Margiela Jazz Club', gender: 'unisex', seasons: ['herbst', 'winter'], notes: ['gourmand'], anlass: ['date'], intensity: 'moderat' },
    { name: 'Maison Margiela Beach Walk', gender: 'unisex', seasons: ['sommer'], notes: ['frisch', 'blumig'], anlass: ['buro'], intensity: 'dezent' },
    { name: 'Byredo Blanche', gender: 'unisex', seasons: ['ganzjahrig'], notes: ['frisch', 'blumig'], anlass: ['buro'], intensity: 'dezent' },
    { name: 'Byredo Bal d’Afrique', gender: 'unisex', seasons: ['fruhling', 'sommer'], notes: ['blumig', 'frisch'], anlass: ['buro'], intensity: 'moderat' },
    { name: 'Byredo Gypsy Water', gender: 'unisex', seasons: ['ganzjahrig'], notes: ['holzig', 'frisch'], anlass: ['buro'], intensity: 'moderat' },
    { name: 'Byredo Mojave Ghost', gender: 'unisex', seasons: ['fruhling'], notes: ['blumig'], anlass: ['buro'], intensity: 'dezent' },
    { name: 'Acqua di Parma Fico di Amalfi', gender: 'unisex', seasons: ['sommer'], notes: ['frisch'], anlass: ['buro'], intensity: 'dezent' },
    { name: 'Jo Malone Wood Sage & Sea Salt', gender: 'unisex', seasons: ['sommer'], notes: ['frisch'], anlass: ['buro'], intensity: 'dezent' },
    { name: 'Marc-Antoine Barrois Tilia', gender: 'unisex', seasons: ['fruhling', 'sommer'], notes: ['blumig', 'frisch'], anlass: ['buro'], intensity: 'moderat' },
    { name: 'Mancera Cedrat Boisé', gender: 'unisex', seasons: ['ganzjahrig'], notes: ['frisch', 'holzig'], anlass: ['buro'], intensity: 'moderat' },
    { name: 'Mancera Instant Crush', gender: 'unisex', seasons: ['herbst', 'winter'], notes: ['gourmand', 'orientalisch'], anlass: ['date'], intensity: 'intensiv' },
    { name: 'Lattafa Khamrah', gender: 'unisex', seasons: ['herbst', 'winter'], notes: ['gourmand', 'orientalisch'], anlass: ['date'], intensity: 'intensiv' },
    { name: 'Louis Vuitton Sun Song', gender: 'unisex', seasons: ['sommer'], notes: ['frisch'], anlass: ['buro'], intensity: 'dezent' },
    { name: 'Louis Vuitton Cactus Garden', gender: 'unisex', seasons: ['sommer'], notes: ['frisch'], anlass: ['buro'], intensity: 'dezent' },
    { name: 'Louis Vuitton California Dream', gender: 'unisex', seasons: ['sommer'], notes: ['frisch'], anlass: ['buro', 'date'], intensity: 'moderat' },
    { name: 'Louis Vuitton On the Beach', gender: 'unisex', seasons: ['sommer'], notes: ['frisch'], anlass: ['buro'], intensity: 'dezent' },
    { name: 'Louis Vuitton City of Stars', gender: 'unisex', seasons: ['fruhling', 'sommer'], notes: ['frisch', 'blumig'], anlass: ['date'], intensity: 'moderat' },
    { name: 'Louis Vuitton Les Sables Roses', gender: 'unisex', seasons: ['herbst', 'winter'], notes: ['orientalisch', 'blumig'], anlass: ['date'], intensity: 'intensiv' },
    { name: 'Louis Vuitton Fleur du Désert', gender: 'unisex', seasons: ['fruhling', 'herbst'], notes: ['blumig', 'orientalisch'], anlass: ['date'], intensity: 'intensiv' },
    { name: 'Louis Vuitton Nuit de Feu', gender: 'unisex', seasons: ['winter'], notes: ['orientalisch'], anlass: ['klassiker'], intensity: 'intensiv' },
  ];

  // Votes for planned scents are sent to the shop inbox through Shopify's own
  // contact form (no account, no WhatsApp). Remembered in localStorage so a
  // visitor can't vote twice for the same scent from one browser.
  var VOTE_KEY = 'quizVotes';

  function readVotes() {
    try { return JSON.parse(localStorage.getItem(VOTE_KEY) || '[]'); } catch (e) { return []; }
  }

  function saveVotes(list) {
    try { localStorage.setItem(VOTE_KEY, JSON.stringify(list)); } catch (e) {}
  }

  function sendContact(subject, body, email) {
    var data = new FormData();
    data.append('form_type', 'contact');
    data.append('utf8', '✓');
    data.append('contact[subject]', subject);
    data.append('contact[body]', body);
    if (email) data.append('contact[email]', email);
    return fetch('/contact', { method: 'POST', body: data, credentials: 'same-origin', keepalive: true });
  }

  var QUESTIONS = [
    {
      key: 'gender',
      heading: 'Für wen suchst du?',
      options: [
        { value: 'herren', label: 'Für ihn' },
        { value: 'damen', label: 'Für sie' },
        { value: 'unisex', label: 'Überrasch mich' },
      ],
    },
    {
      key: 'season',
      heading: 'Welche Jahreszeit passt am besten?',
      options: [
        { value: 'fruhling', label: 'Frühling' },
        { value: 'sommer', label: 'Sommer' },
        { value: 'herbst', label: 'Herbst' },
        { value: 'winter', label: 'Winter' },
        { value: 'ganzjahrig', label: 'Das ganze Jahr' },
      ],
    },
    {
      key: 'anlass',
      heading: 'Wofür soll der Duft hauptsächlich sein?',
      options: [
        { value: 'buro', label: 'Alltag & Büro' },
        { value: 'date', label: 'Date & besondere Abende' },
        { value: 'klassiker', label: 'Ein zeitloser Signature-Duft' },
      ],
    },
    {
      key: 'notes',
      heading: 'Welche Richtung zieht dich an?',
      options: [
        { value: 'frisch', label: 'Frisch & aquatisch' },
        { value: 'holzig', label: 'Holzig & würzig' },
        { value: 'orientalisch', label: 'Orientalisch & warm' },
        { value: 'blumig', label: 'Blumig & elegant' },
        { value: 'gourmand', label: 'Süß & verspielt' },
      ],
    },
    {
      key: 'intensity',
      heading: 'Dezent oder auffällig?',
      options: [
        { value: 'dezent', label: 'Eine dezente Begleitung' },
        { value: 'intensiv', label: 'Darf ruhig auffallen' },
      ],
    },
  ];

  function scoreFragrance(f, answers) {
    if (answers.gender !== 'unisex' && f.gender !== 'unisex' && f.gender !== answers.gender) {
      return -1;
    }
    var score = 0;
    if (f.seasons.indexOf(answers.season) !== -1 || f.seasons.indexOf('ganzjahrig') !== -1) score += 3;
    if (f.notes.indexOf(answers.notes) !== -1) score += 3;
    if (f.anlass.indexOf(answers.anlass) !== -1) score += 2;
    // "moderat" sits between the two answer options, so it's a half match for either.
    if (f.intensity === answers.intensity) score += 2;
    else if (f.intensity === 'moderat') score += 1;
    return score;
  }

  // Among ties, shuffle so repeated similar answers don't always surface
  // the exact same fragrance in the exact same order.
  function shuffle(list) {
    for (var i = list.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var tmp = list[i];
      list[i] = list[j];
      list[j] = tmp;
    }
    return list;
  }

  function rankAndPick(list, answers, count) {
    var scored = list.map(function (f) {
      var score = scoreFragrance(f, answers);
      return { fragrance: f, score: score };
    });
    // A wrong-gender fragrance (score -1) is never shown, even to fill a slot.
    scored = shuffle(scored.filter(function (r) { return r.score >= 0; }));
    scored.sort(function (a, b) { return b.score - a.score; });
    return scored.slice(0, count).map(function (r) { return r.fragrance; });
  }

  var TOTAL_RESULTS = 6;

  // Attach the live image/price from the section; a product that isn't in the
  // live catalog (deleted or unpublished) is left out instead of showing broken.
  function applyLiveCatalog() {
    var el = document.getElementById('FragranceQuizCatalog');
    var catalog = {};
    try { catalog = JSON.parse(el.textContent); } catch (e) { return; }
    OWN_FRAGRANCES = OWN_FRAGRANCES.filter(function (f) {
      var live = catalog[f.handle];
      if (!live || !live.image) return false;
      f.image = live.image;
      f.white = live.white;
      f.price = live.price;
      return true;
    });
  }

  function getResults(answers) {
    // We carry only one pure women's scent (+ unisex ones), so women see at
    // most 2 of ours; the rest of the six are well-matching other scents.
    var ownMax = answers.gender === 'damen' ? 2 : 3;
    var own = rankAndPick(OWN_FRAGRANCES, answers, ownMax);
    var planned = rankAndPick(PLANNED_FRAGRANCES, answers, TOTAL_RESULTS - own.length);
    return { own: own, planned: planned };
  }

  function escapeHtml(text) {
    return String(text).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  // "Louis Vuitton Spell on You" -> brand + scent for the two-line card title
  var BRANDS = ['Louis Vuitton', 'Parfums de Marly', 'Tom Ford', 'Xerjoff', 'Chanel', 'Dior', 'Prada', 'Giorgio Armani',
    'Jean Paul Gaultier', 'Paco Rabanne', 'Yves Saint Laurent', 'Dolce & Gabbana', 'Hugo Boss', 'Givenchy', 'Valentino',
    'Viktor & Rolf', 'Armaf', 'Narciso Rodriguez', 'Gucci', 'Guerlain', 'Kayali', 'Carolina Herrera', 'Burberry', 'Kilian',
    'Zadig & Voltaire', 'Initio', 'Montale', 'Maison Margiela', 'Byredo', 'Acqua di Parma', 'Jo Malone', 'Marc-Antoine Barrois',
    'Mancera', 'Lattafa'];

  function splitName(name) {
    for (var i = 0; i < BRANDS.length; i++) {
      if (name.indexOf(BRANDS[i] + ' ') === 0) return { brand: BRANDS[i], scent: name.slice(BRANDS[i].length + 1) };
    }
    return { brand: '', scent: name };
  }

  function renderResults(container, answers) {
    var results = getResults(answers);
    var html = '<div class="fragrance-quiz__results-inner">';
    html += '<p class="fragrance-quiz__eyebrow">Dein Ergebnis</p>';
    html += '<h2 class="fragrance-quiz__results-heading">Diese Düfte passen zu dir</h2>';

    if (results.own.length) {
      html += '<p class="fragrance-quiz__group-title">Bei uns zum Testen</p>';
      html += '<div class="fragrance-quiz__results-grid">';
      results.own.forEach(function (f) {
        var n = splitName(f.name);
        // No ?variant= on purpose: the product page preselects the recommended 3 ml size.
        html += '<a class="fragrance-quiz__result-card" href="/products/' + f.handle + '">'
          + '<span class="fragrance-quiz__result-image' + (f.white ? ' fragrance-quiz__result-image--white' : '') + '"><img src="' + escapeHtml(f.image) + '" alt="' + escapeHtml(f.name) + '" loading="lazy"></span>'
          + '<span class="fragrance-quiz__result-brand">' + escapeHtml(n.brand) + '</span>'
          + '<span class="fragrance-quiz__result-name">' + escapeHtml(n.scent) + '</span>'
          + '<span class="fragrance-quiz__result-price">ab ' + f.price + ' €</span>'
          + '<span class="fragrance-quiz__result-cta">Probe ansehen →</span>'
          + '</a>';
      });
      html += '</div>';
    }

    if (results.planned.length) {
      html += '<div class="fragrance-quiz__planned">';
      html += '<p class="fragrance-quiz__group-title">Bald bei uns</p>';
      html += '<p class="fragrance-quiz__group-text">Diese Düfte passen ebenfalls zu dir – wir nehmen sie als Nächstes ins Sortiment auf. Tippe auf „Will ich testen“: Die Düfte mit den meisten Stimmen holen wir zuerst.</p>';
      html += '<div class="fragrance-quiz__planned-list">';
      results.planned.forEach(function (f) {
        var n = splitName(f.name);
        var voted = readVotes().indexOf(f.name) !== -1;
        html += '<div class="fragrance-quiz__planned-item">'
          + '<span class="fragrance-quiz__planned-name"><span class="fragrance-quiz__result-brand">' + escapeHtml(n.brand) + '</span>'
          + '<span class="fragrance-quiz__result-name">' + escapeHtml(n.scent) + '</span></span>'
          + '<button type="button" class="fragrance-quiz__vote' + (voted ? ' is-on' : '') + '" data-vote="' + escapeHtml(f.name) + '" aria-pressed="' + voted + '">'
          + '<svg viewBox="0 0 24 24" width="15" height="15" aria-hidden="true"><path d="M12 20s-7-4.35-7-10a4 4 0 0 1 7-2.65A4 4 0 0 1 19 10c0 5.65-7 10-7 10Z" fill="currentColor" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/></svg>'
          + '<span>' + (voted ? 'Gemerkt' : 'Will ich testen') + '</span></button>'
          + '</div>';
      });
      html += '</div>';
      html += '<form class="fragrance-quiz__notify" hidden>'
        + '<p class="fragrance-quiz__notify-text">Sollen wir dir Bescheid geben, sobald deine gemerkten Düfte da sind?</p>'
        + '<div class="fragrance-quiz__notify-row"><label class="visually-hidden" for="QuizNotifyEmail">Deine E-Mail</label>'
        + '<input id="QuizNotifyEmail" type="email" required placeholder="Deine E-Mail-Adresse" autocomplete="email">'
        + '<button type="submit">Benachrichtigen</button></div>'
        + '<p class="fragrance-quiz__notify-note">Wir nutzen deine E-Mail nur für diese eine Nachricht – kein Newsletter.</p>'
        + '</form>';
      html += '</div>';
    }

    html += '<button type="button" class="fragrance-quiz__restart">Test neu starten</button>';
    html += '</div>';
    container.innerHTML = html;
    container.hidden = false;

    var notify = container.querySelector('.fragrance-quiz__notify');
    var showNotify = function () {
      if (notify && readVotes().length) notify.hidden = false;
    };
    showNotify();

    container.querySelectorAll('[data-vote]').forEach(function (button) {
      button.addEventListener('click', function () {
        if (button.classList.contains('is-on')) return;
        var name = button.getAttribute('data-vote');
        button.classList.add('is-on');
        button.setAttribute('aria-pressed', 'true');
        button.querySelector('span').textContent = 'Gemerkt';
        var votes = readVotes();
        if (votes.indexOf(name) === -1) {
          votes.push(name);
          saveVotes(votes);
          sendContact('Duft-Test: Stimme für ' + name, 'Stimme aus dem Duft-Test: ' + name).catch(function () {});
        }
        showNotify();
      });
    });

    if (notify) {
      notify.addEventListener('submit', function (event) {
        event.preventDefault();
        var email = notify.querySelector('input').value.trim();
        if (!email) return;
        sendContact('Duft-Test: Benachrichtigung gewünscht', 'Bitte Bescheid geben, sobald diese Düfte da sind: ' + readVotes().join(', '), email)
          .catch(function () {});
        notify.innerHTML = '<p class="fragrance-quiz__notify-done">Danke! Wir melden uns, sobald deine Düfte bei uns sind.</p>';
      });
    }

    container.querySelector('.fragrance-quiz__restart').addEventListener('click', function () {
      container.hidden = true;
      container.innerHTML = '';
      startQuiz(container.parentElement);
    });
  }

  function startQuiz(root) {
    var stepEl = root.querySelector('.fragrance-quiz__step');
    var resultsEl = root.querySelector('.fragrance-quiz__results');
    var answers = {};
    var index = 0;

    function renderStep() {
      var q = QUESTIONS[index];
      var html = '<p class="fragrance-quiz__eyebrow">Frage ' + (index + 1) + ' von ' + QUESTIONS.length + '</p>';
      html += '<h2 class="fragrance-quiz__question">' + q.heading + '</h2>';
      html += '<div class="fragrance-quiz__options">';
      q.options.forEach(function (opt) {
        html += '<button type="button" class="fragrance-quiz__option" data-value="' + opt.value + '">' + opt.label + '</button>';
      });
      html += '</div>';
      stepEl.innerHTML = html;

      var buttons = stepEl.querySelectorAll('.fragrance-quiz__option');
      buttons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          answers[q.key] = btn.getAttribute('data-value');
          index += 1;
          if (index < QUESTIONS.length) {
            renderStep();
          } else {
            stepEl.hidden = true;
            renderResults(resultsEl, answers);
          }
        });
      });
    }

    stepEl.hidden = false;
    resultsEl.hidden = true;
    renderStep();
  }

  applyLiveCatalog();
  document.querySelectorAll('[data-fragrance-quiz]').forEach(function (root) {
    startQuiz(root);
  });
})();
